module.exports = __webpack_public_path__ + "resources/image_fail.c0b6e362a8244190.png";